import { staticCollectionFieldsMap } from 'admin/components/pages/Collections/CollectionEditor/CollectionTable/utils';
import { CmsCollectionFieldItem, CmsFieldType } from 'types/cms';

export const getCollectionFieldOptions = (
	fields: CmsCollectionFieldItem[],
	allowedTypes: CmsFieldType[] | 'any',
	staticFields: Parameters<typeof staticCollectionFieldsMap.get>[0][] = []
): Array<{ value: string; label: string }> => {
	if (!fields) {
		return [];
	}

	const fieldsList = [...fields, ...staticFields.map(f => staticCollectionFieldsMap.get(f)!)];

	return fieldsList
		.filter(field => (allowedTypes === 'any' ? true : allowedTypes.includes(field.type)))
		.map(field => ({ value: field.key, label: field.name }));
};
